.container {
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-6) var(--tuna-spacing-2);
  text-align: center;
}

/* Focused only so screen readers announce it; it is not interactive, so no ring (WCAG 2.4.7 covers controls). */
.heading:focus {
  outline: none;
}

.body {
  max-width: 48ch;
  text-wrap: balance;
  overflow-wrap: anywhere;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--tuna-spacing-1);
}
